const state = {
  warehouse: [],
  selectedWarehouse: undefined
}

const actions = {
  setWarehouse ({ commit }, payload) {
    // const filteredWh = payload.filter((p) => p.sellsukiWarehouse !== 'khonkaen')
    commit('SET_WAREHOUSE', payload)
    commit('SELECT_WAREHOUSE', payload[0].sellsukiWarehouse)
  },
  selectWarehouse ({ commit }, payload) {
    commit('SELECT_WAREHOUSE', payload)
  }
}

const mutations = {
  SET_WAREHOUSE (state, payload) {
    state.warehouse = payload
  },
  SELECT_WAREHOUSE (state, payload) {
    state.selectedWarehouse = payload
  }
}

const getters = {
  warehouse: (state) => state.warehouse,
  selectedWarehouse: (state) => state.selectedWarehouse
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
